import {AxiosRequestConfig, Method} from 'axios';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface QueryDefaultInput<TData = any> {
  url: string;
  params?: any;
  data?: TData;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface QueryInput<TData = any> extends QueryDefaultInput<TData> {
  method?: Method | string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type QueryInputAsArray<TData = any> = [
  QueryInput<TData>['url'],
  QueryInput<TData>['method'],
  QueryInput<TData>['params']?,
  ...string[]
];

export function extractKey<TData>({
  url,
  method,
  params,
  data,
}: QueryInput<TData>): QueryInputAsArray<TData> {
  return [
    url.toLowerCase(),
    method || 'get',
    ...(params ? [JSON.stringify(params).toLowerCase()] : []),
    ...(data ? [JSON.stringify(data).toLowerCase()] : []),
  ];
}

export function extractGridKey<TData>(
  dataServiceUrl: string,
  dataServiceConfig?: AxiosRequestConfig<TData>
): QueryInputAsArray<TData> {
  return extractKey({
    url: dataServiceUrl,
    method: dataServiceConfig?.method,
    params: dataServiceConfig?.params,
    data: dataServiceConfig?.data,
  });
}
